import{ createContext } from 'react'

const ColorContext = createContext({
    color: '#000000'
})

export default ColorContext